import * as constants from './constants';
import * as dispatchers from './dispatchers';
import * as selectors from './selectors';

import {rest} from './rest';

/**
 * Public API for the documents redux module.
 */
export const metrics = {
    rest,
    constants,
    selectors,
    dispatchers,
};
